// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-sidebar {
  width: 300px;
  height: 100vh;
  display: flex;
  flex-direction: column;
  padding: 16px;
  border-right: 1px solid #e5e5e5;
  background: #ffffff;
}
.app-sidebar .company-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 16px;
}
.app-sidebar .company-header .company-logo img {
  width: 40px;
  height: 40px;
}
.app-sidebar .company-header .company-text {
  display: flex;
  flex-direction: column;
  font-size: 13px;
}
.app-sidebar .company-header .company-text .company-main {
  font-weight: 600;
}
.app-sidebar .company-header .company-text .company-amp {
  margin-right: 4px;
}
.app-sidebar .company-header .company-text .company-sub {
  color: #777;
}
.app-sidebar .new-analysis-btn {
  width: 100%;
  margin-bottom: 12px;
}
.app-sidebar .session-list {
  flex: 1 1;
  overflow-y: auto;
  margin-top: 8px;
}
.app-sidebar .sidebar-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid #eee;
  padding-top: 10px;
  margin-top: 10px;
}
.app-sidebar .sidebar-footer .sidebar-user-name {
  font-size: 13px;
  font-weight: 600;
}
.app-sidebar .sidebar-footer .sidebar-user-role {
  font-size: 11px;
  color: #777;
}
.app-sidebar .sidebar-footer .logout-btn {
  font-size: 12px;
}
.app-sidebar #new-analysis-btn {
  background: #4f46e5;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  border: none;
  border-radius: 10px;
  padding: 10px 16px;
  margin-bottom: 16px;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(79, 70, 229, 0.3);
  transition: all 0.2s ease;
}
.app-sidebar .chat-session {
  padding: 8px 10px;
  border-radius: 8px;
  cursor: pointer;
  margin-bottom: 6px;
  background: white;
  font-size: 13px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: background 0.15s;
}
.app-sidebar .chat-session.active {
  background: #e0e7ff;
  font-weight: 600;
}
.app-sidebar .session-actions {
  display: flex;
  gap: 4px;
}
.app-sidebar .session-actions button {
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.app-sidebar .session-actions button .pi {
  display: flex;
  align-items: center;
  width: 16px;
  height: 16px;
  color: #4f46e5;
  opacity: 0.9;
  transition: transform 0.1s ease, opacity 0.1s ease;
}
.app-sidebar .logout-btn {
  margin-left: 8px;
  padding: 8px 18px;
  border-radius: 10px;
  border: none;
  cursor: pointer;
  font-size: 11px;
  font-weight: 600;
  background: linear-gradient(135deg, #4f46e5, #6366f1);
  color: #ffffff;
  box-shadow: 0 6px 14px rgba(79, 70, 229, 0.35);
}

/* Rename Chat Dialog */
.p-dialog.rename-chat-dialog,
.p-dialog.logout-dialog,
.p-dialog.delete-chat-dialog {
  border-radius: 12px;
  overflow: hidden;
  background-color: #ffffff;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
}
.p-dialog.rename-chat-dialog .p-dialog-header,
.p-dialog.logout-dialog .p-dialog-header,
.p-dialog.delete-chat-dialog .p-dialog-header {
  padding: 1rem 1.25rem;
  background: var(--surface-card);
  border-bottom: 1px solid var(--surface-border);
}
.p-dialog.rename-chat-dialog .p-dialog-header .p-dialog-title,
.p-dialog.logout-dialog .p-dialog-header .p-dialog-title,
.p-dialog.delete-chat-dialog .p-dialog-header .p-dialog-title {
  font-size: 1rem;
  font-weight: 600;
  color: var(--text-color);
}
.p-dialog.rename-chat-dialog .p-dialog-content,
.p-dialog.logout-dialog .p-dialog-content,
.p-dialog.delete-chat-dialog .p-dialog-content {
  padding: 0 1.25rem 1.25rem 1.25rem;
}
.p-dialog.rename-chat-dialog .p-dialog-content .rename-input,
.p-dialog.logout-dialog .p-dialog-content .rename-input,
.p-dialog.delete-chat-dialog .p-dialog-content .rename-input {
  width: 100%;
  padding: 0.6rem 0.75rem;
  border-radius: 8px;
  font-size: 0.9rem;
  border: 1px solid #ccc;
}
.p-dialog.rename-chat-dialog .p-dialog-footer,
.p-dialog.logout-dialog .p-dialog-footer,
.p-dialog.delete-chat-dialog .p-dialog-footer {
  padding: 1rem 0 0 0;
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
  border-top: 1px solid var(--surface-border);
}
.p-dialog.rename-chat-dialog .p-dialog-footer .p-button,
.p-dialog.logout-dialog .p-dialog-footer .p-button,
.p-dialog.delete-chat-dialog .p-dialog-footer .p-button {
  min-width: 80px;
  border-radius: 8px;
  margin-left: 8px;
  padding: 8px 18px;
  border-radius: 10px;
  border: none;
  cursor: pointer;
  font-size: 11px;
  font-weight: 600;
  background: linear-gradient(135deg, #4f46e5, #6366f1);
  color: #ffffff;
  box-shadow: 0 6px 14px rgba(79, 70, 229, 0.35);
}
.p-dialog.rename-chat-dialog .p-dialog-footer .p-button.p-button-text,
.p-dialog.logout-dialog .p-dialog-footer .p-button.p-button-text,
.p-dialog.delete-chat-dialog .p-dialog-footer .p-button.p-button-text {
  background: none;
  color: #4f46e5;
  box-shadow: none;
}

.company-amp {
  font-family: "Georgia", serif;
  font-style: italic;
  font-size: 14.5px;
  color: #9ca3af;
}

.company-sub {
  font-size: 14px;
  color: #6b7280;
  letter-spacing: 0.02em;
  font-weight: 500;
}

.company-main {
  font-weight: 600;
  font-size: 17px;
  color: #111827;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/components/_sidebar.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;EACA,+BAAA;EACA,mBAAA;AACJ;AACI;EACI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;AACR;AAEY;EACI,WAAA;EACA,YAAA;AAAhB;AAIQ;EACI,aAAA;EACA,sBAAA;EACA,eAAA;AAFZ;AAIY;EACI,gBAAA;AAFhB;AAKY;EACI,iBAAA;AAHhB;AAMY;EACI,WAAA;AAJhB;AASI;EACI,WAAA;EACA,mBAAA;AAPR;AAUI;EACI,SAAA;EACA,gBAAA;EACA,eAAA;AARR;AAWI;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,0BAAA;EACA,iBAAA;EACA,gBAAA;AATR;AAWQ;EACI,eAAA;EACA,gBAAA;AATZ;AAYQ;EACI,eAAA;EACA,WAAA;AAVZ;AAaQ;EACI,eAAA;AAXZ;AAeI;EACI,mBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,6CAAA;EACA,yBAAA;AAbR;AAgBI;EACI,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,4BAAA;AAdR;AAgBQ;EACI,mBAAA;EACA,gBAAA;AAdZ;AAkBI;EACI,aAAA;EACA,QAAA;AAhBR;AAkBQ;EACI,gBAAA;EACA,YAAA;EACA,eAAA;EACA,UAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;AAhBZ;AAkBY;EACI,aAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,YAAA;EACA,kDAAA;AAhBhB;AAqBI;EACI,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,qDAAA;EACA,cAAA;EACA,8CAAA;AAnBR;;AAuBA,uBAAA;AACA;;;EAGI,mBAAA;EACA,gBAAA;EACA,yBAAA;EACA,uCAAA;AApBJ;AAsBI;;;EACI,qBAAA;EACA,+BAAA;EACA,8CAAA;AAlBR;AAoBQ;;;EACI,eAAA;EACA,gBAAA;EACA,wBAAA;AAhBZ;AAoBI;;;EACI,kCAAA;AAhBR;AAkBQ;;;EACI,WAAA;EACA,uBAAA;EACA,kBAAA;EACA,iBAAA;EACA,sBAAA;AAdZ;AAkBI;;;EACI,mBAAA;EACA,aAAA;EACA,yBAAA;EACA,WAAA;EACA,2CAAA;AAdR;AAgBQ;;;EACI,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,qDAAA;EACA,cAAA;EACA,8CAAA;AAZZ;AAcY;;;EACI,gBAAA;EACA,cAAA;EACA,gBAAA;AAVhB;;AAkBA;EACI,6BAAA;EACA,kBAAA;EACA,iBAAA;EACA,cAAA;AAfJ;;AAkBA;EACI,eAAA;EACA,cAAA;EACA,sBAAA;EACA,gBAAA;AAfJ;;AAkBA;EACI,gBAAA;EACA,eAAA;EACA,cAAA;AAfJ","sourcesContent":[".app-sidebar {\n    width: 300px;\n    height: 100vh;\n    display: flex;\n    flex-direction: column;\n    padding: 16px;\n    border-right: 1px solid #e5e5e5;\n    background: #ffffff;\n\n    .company-header {\n        display: flex;\n        align-items: center;\n        gap: 10px;\n        margin-bottom: 16px;\n\n        .company-logo {\n            img {\n                width: 40px;\n                height: 40px;\n            }\n        }\n\n        .company-text {\n            display: flex;\n            flex-direction: column;\n            font-size: 13px;\n\n            .company-main {\n                font-weight: 600;\n            }\n\n            .company-amp {\n                margin-right: 4px;\n            }\n\n            .company-sub {\n                color: #777;\n            }\n        }\n    }\n\n    .new-analysis-btn {\n        width: 100%;\n        margin-bottom: 12px;\n    }\n\n    .session-list {\n        flex: 1;\n        overflow-y: auto;\n        margin-top: 8px;\n    }\n\n    .sidebar-footer {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        border-top: 1px solid #eee;\n        padding-top: 10px;\n        margin-top: 10px;\n\n        .sidebar-user-name {\n            font-size: 13px;\n            font-weight: 600;\n        }\n\n        .sidebar-user-role {\n            font-size: 11px;\n            color: #777;\n        }\n\n        .logout-btn {\n            font-size: 12px;\n        }\n    }\n\n    #new-analysis-btn {\n        background: #4f46e5;\n        color: #fff;\n        font-size: 14px;\n        font-weight: 600;\n        border: none;\n        border-radius: 10px;\n        padding: 10px 16px;\n        margin-bottom: 16px;\n        cursor: pointer;\n        box-shadow: 0 4px 12px rgba(79, 70, 229, 0.3);\n        transition: all 0.2s ease;\n    }\n\n    .chat-session {\n        padding: 8px 10px;\n        border-radius: 8px;\n        cursor: pointer;\n        margin-bottom: 6px;\n        background: white;\n        font-size: 13px;\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        transition: background 0.15s;\n\n        &.active {\n            background: #e0e7ff;\n            font-weight: 600;\n        }\n    }\n\n    .session-actions {\n        display: flex;\n        gap: 4px;\n\n        button {\n            background: none;\n            border: none;\n            cursor: pointer;\n            padding: 0;\n            display: inline-flex;\n            align-items: center;\n            justify-content: center;\n\n            .pi {\n                display: flex;\n                align-items: center;\n                width: 16px;\n                height: 16px;\n                color: #4f46e5;\n                opacity: 0.9;\n                transition: transform 0.1s ease, opacity 0.1s ease;\n            }\n        }\n    }\n\n    .logout-btn {\n        margin-left: 8px;\n        padding: 8px 18px;\n        border-radius: 10px;\n        border: none;\n        cursor: pointer;\n        font-size: 11px;\n        font-weight: 600;\n        background: linear-gradient(135deg, #4f46e5, #6366f1);\n        color: #ffffff;\n        box-shadow: 0 6px 14px rgba(79, 70, 229, 0.35);\n    }\n}\n\n/* Rename Chat Dialog */\n.p-dialog.rename-chat-dialog,\n.p-dialog.logout-dialog,\n.p-dialog.delete-chat-dialog {\n    border-radius: 12px;\n    overflow: hidden;\n    background-color: #ffffff;\n    box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);\n\n    .p-dialog-header {\n        padding: 1rem 1.25rem;\n        background: var(--surface-card);\n        border-bottom: 1px solid var(--surface-border);\n\n        .p-dialog-title {\n            font-size: 1rem;\n            font-weight: 600;\n            color: var(--text-color);\n        }\n    }\n\n    .p-dialog-content {\n        padding: 0 1.25rem 1.25rem 1.25rem;\n\n        .rename-input {\n            width: 100%;\n            padding: 0.6rem 0.75rem;\n            border-radius: 8px;\n            font-size: 0.9rem;\n            border: 1px solid #ccc;\n        }\n    }\n\n    .p-dialog-footer {\n        padding: 1rem 0 0 0;\n        display: flex;\n        justify-content: flex-end;\n        gap: 0.5rem;\n        border-top: 1px solid var(--surface-border);\n\n        .p-button {\n            min-width: 80px;\n            border-radius: 8px;\n            margin-left: 8px;\n            padding: 8px 18px;\n            border-radius: 10px;\n            border: none;\n            cursor: pointer;\n            font-size: 11px;\n            font-weight: 600;\n            background: linear-gradient(135deg, #4f46e5, #6366f1);\n            color: #ffffff;\n            box-shadow: 0 6px 14px rgba(79, 70, 229, 0.35);\n\n            &.p-button-text {\n                background: none;\n                color: #4f46e5;\n                box-shadow: none;\n            }\n        }\n\n\n    }\n}\n\n.company-amp {\n    font-family: \"Georgia\", serif;\n    font-style: italic;\n    font-size: 14.5px;\n    color: #9ca3af;\n}\n\n.company-sub {\n    font-size: 14px;\n    color: #6b7280;\n    letter-spacing: 0.02em;\n    font-weight: 500;\n}\n\n.company-main {\n    font-weight: 600;\n    font-size: 17px;\n    color: #111827;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
